import { appToken, serverNodeApiUrl } from "../../index";

const token =
    "Bearer " + "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdGF0dXMiOiJVTkJMT0NLRUQiLCJpZCI6ODkyMjA2ODc5MCwibW9iaWxlIjoiJDJiJDEwJG43TEZEeTJSaXJEa1lYelNuSWlIcU90WlUzcC9SaU9jZUNmUWZLVzFQYzV6WWZabzRNZElpIiwidXNlclR5cGUiOiJBRE1JTiIsInVwZGF0ZWRBdCI6IjIwMjUtMDItMjZUMDk6MDg6MDIuNDkxWiIsImNyZWF0ZWRBdCI6IjIwMjUtMDItMjZUMDk6MDg6MDIuNDkxWiIsImlhdCI6MTc0MDU2MDg4MiwiZXhwIjoxNzQzMTg4ODgyLCJpc3MiOiJEVUJ1ZGR5In0.QzQhSkCs2juC-06HGHwBbXIDVTPLjv78715QMcXIROM";

// Helper function to create headers
const createHeaders = () => {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");
    headers.append("Authorization", token);
    return headers;
};
const LIMIT = 1000;

// Helper function to normalize report status
const normalizeReportStatus = (data) => {
    if (!data || !Array.isArray(data.rows)) return data;

    data.rows = data.rows.map(row => {
        if (row.reportStatus) {
            // Ensure status is always uppercase
            row.reportStatus = row.reportStatus.toUpperCase();
            // Validate that it's either RESOLVED or UNRESOLVED
            if (row.reportStatus !== 'RESOLVED' && row.reportStatus !== 'UNRESOLVED') {
                row.reportStatus = 'UNRESOLVED'; // Default to UNRESOLVED if invalid
            }
        } else {
            row.reportStatus = 'UNRESOLVED'; // Default if not provided
        }
        return row;
    });

    return data;
};

export const getAllReportedQuestions = async (page, limit, status, startDate, endDate, examTestTypeId, examTestTypeSubcategoryId) => {
    try {
        const headers = createHeaders();

        // Build the query string with all filter parameters
        let queryParams = new URLSearchParams();
        queryParams.append('page', page);
        queryParams.append('pageLimit', limit || 25);

        // Only add status if it's not ALL (empty string)
        if (status) {
            queryParams.append('reportStatus', status);
        }

        // Add date range filters if provided
        if (startDate) {
            queryParams.append('startDate', new Date(startDate).toISOString());
        }

        if (endDate) {
            queryParams.append('endDate', new Date(endDate).toISOString());
        }

        // Add subject and category filters if provided
        if (examTestTypeId) {
            queryParams.append('examTestTypeId', examTestTypeId);
        }

        if (examTestTypeSubcategoryId) {
            queryParams.append('examTestTypeSubcategoryId', examTestTypeSubcategoryId);
        }

        const url = `${serverNodeApiUrl}testseries/admin/reportQuestion/getUserReports?${queryParams.toString()}`;
        console.log("API request URL:", url);

        const response = await fetch(url, {
            method: "GET",
            headers,
        });

        if (response.status === 200) {
            const data = await response.json();
            if (data && data.status) {
                // Normalize report statuses before returning
                data.data = normalizeReportStatus(data.data);
            }
            return data;
        } else {
            const errorText = await response.text();
            throw new Error(`Server responded with status ${response.status}: ${errorText}`);
        }
    } catch (e) {
        console.error("Error in getAllReportedQuestions:", e);
        return { status: false, message: e.message || "Failed to fetch reported questions" };
    }
};

export const updateReportedQuestionSol = async (id, solution) => {
    try {
        if (!id) {
            throw new Error("Missing required parameter: id");
        }

        const headers = createHeaders();
        const response = await fetch(
            serverNodeApiUrl +
            "testseries/admin/testSeriesQuestionLanguageVariant/updateVariant",
            {
                method: "PATCH",
                headers,
                body: JSON.stringify({ id, solution })
            }
        );

        if (response.status === 200) {
            return { status: true, message: "Solution updated successfully." };
        } else {
            const errorText = await response.text();
            throw new Error(`Server responded with status ${response.status}: ${errorText}`);
        }
    } catch (e) {
        console.error("Error in updateReportedQuestionSol:", e);
        return { status: false, message: e.message || "Failed to update solution" };
    }
};

export const updateReportedQuestionVal = async (id, value) => {
    try {
        if (!id) {
            throw new Error("Missing required parameter: id");
        }

        const headers = createHeaders();
        const response = await fetch(
            serverNodeApiUrl +
            "testseries/admin/testSeriesQuestionLanguageVariant/updateVariant",
            {
                method: "PATCH",
                headers,
                body: JSON.stringify({ id, value })
            }
        );

        if (response.status === 200) {
            return { status: true, message: "Question value updated successfully." };
        } else {
            const errorText = await response.text();
            throw new Error(`Server responded with status ${response.status}: ${errorText}`);
        }
    } catch (e) {
        console.error("Error in updateReportedQuestionVal:", e);
        return { status: false, message: e.message || "Failed to update question value" };
    }
};

export const updateReportedQuestionCorrectPrompt = async (id, correctPrompt) => {
    try {
        if (!id) {
            throw new Error("Missing required parameter: id");
        }

        const headers = createHeaders();
        const response = await fetch(
            serverNodeApiUrl +
            "testseries/admin/testSeriesQuestion/updateQuestion",
            {
                method: "PATCH",
                headers,
                body: JSON.stringify({ id, correctPrompt })
            }
        );

        if (response.status === 200) {
            return { status: true, message: "Correct prompt updated successfully." };
        } else {
            const errorText = await response.text();
            throw new Error(`Server responded with status ${response.status}: ${errorText}`);
        }
    } catch (e) {
        console.error("Error in updateReportedQuestionCorrectPrompt:", e);
        return { status: false, message: e.message || "Failed to update correct prompt" };
    }
};

export const updateReportedQuestionStatus = async (id, reportStatus) => {
    try {
        if (!id) {
            throw new Error("Missing required parameter: id");
        }

        // Ensure status is always uppercase and valid
        reportStatus = reportStatus ? reportStatus.toUpperCase() : '';
        if (reportStatus !== 'RESOLVED' && reportStatus !== 'UNRESOLVED') {
            throw new Error("Invalid report status: must be RESOLVED or UNRESOLVED");
        }

        const headers = createHeaders();
        const response = await fetch(
            serverNodeApiUrl +
            "testseries/admin/reportQuestion/updateReportStatus",
            {
                method: "PATCH",
                headers,
                body: JSON.stringify({ id, reportStatus })
            }
        );

        if (response.status === 200) {
            return { status: true, message: "Report status updated successfully." };
        } else {
            const errorText = await response.text();
            throw new Error(`Server responded with status ${response.status}: ${errorText}`);
        }
    } catch (e) {
        console.error("Error in updateReportedQuestionStatus:", e);
        return { status: false, message: e.message || "Failed to update report status" };
    }
};


export const getExamTestType = async () => {
    try {
        const headers = createHeaders();
        const response = await fetch(
            serverNodeApiUrl +
            `testseries/admin/examTestType/testSeriesExamTestType/1/0/${LIMIT}`,
            {
                method: "GET",
                headers,
            }
        );

        if (response.status === 200) {
            const data = await response.json();
            return data
        } else {
            const errorText = await response.text();
            throw new Error(`Server responded with status ${response.status}: ${errorText}`);
        }
    } catch (e) {
        console.error("Error in updateReportedQuestionStatus:", e);
        return { status: false, message: e.message || "Failed to update report status" };
    }
}

export const getExamTestTypeSubCategory = async (id) => {
    try {
        const headers = createHeaders();
        const response = await fetch(
            serverNodeApiUrl +
            `testseries/public/testseriesexamtesttypesubcategory/getByExamTestTypeId/${id}`,
            {
                method: "GET",
                headers,
            }
        );

        if (response.status === 200) {
            const data = await response.json();
            return data
        } else {
            const errorText = await response.text();
            throw new Error(`Server responded with status ${response.status}: ${errorText}`);
        }
    } catch (e) {
        console.error("Error in updateReportedQuestionStatus:", e);
        return { status: false, message: e.message || "Failed to update report status" };
    }
}